export const sortArrayByProperty = (array, property) => {
  const sortFunction = (a, b) => {
    const aValue = a[property];
    const bValue = b[property];

    if (aValue === undefined || bValue === undefined) {
      return 0;
    }

    return typeof aValue === "number" && typeof bValue === "number"
      ? aValue - bValue
      : aValue.localeCompare(bValue);
  };

  return [...array].sort(sortFunction);
};
